import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import classNames from 'classnames';

import { Typography } from '../Typography';

import styles from './Callout.module.scss';

export interface ICalloutProps
    extends Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'prefix'> {
    children?: React.ReactNode;
    prefix?: React.ReactNode;
    type?: 'info' | 'warning' | 'error' | 'neutral';
    fullWidth?: boolean;
    multiline?: boolean;
}

export const Callout: React.FC<ICalloutProps> = ({
    fullWidth = true,
    multiline = false,
    type = 'info',
    className,
    children,
    prefix,
    ...props
}) => {
    return (
        <div
            className={classNames(
                styles.wrapper,
                styles[`type-${type}`],
                {
                    [styles.fullWidth]: !!fullWidth,
                    [styles.multiline]: multiline,
                },
                className,
            )}
            {...props}
        >
            {prefix && <div className={styles.iconWrapper}>{prefix}</div>}
            <Typography component="span" color="inherit" className={styles.content}>
                {children}
            </Typography>
        </div>
    );
};
